
















import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";
import OneService from "@/components/medicalEdit/specification/part/OneService.vue";

@Component({
  components: {
    NumberInput
  }
})
export default class ManagementExpense extends OneService {
  @Prop({ default: 0 }) fixmoney!: number;

  get Fixmoney() {
    return this.fixmoney;
  }
  set Fixmoney(newValue) {
    this.Totalmoney = newValue + this.Unitprice * this.Days;
    this.changealltotal();
    this.updateFixmoney(newValue);
  }

  get Unitprice() {
    return this.unitprice;
  }
  set Unitprice(newValue) {
    if (this.Days) {
      this.Totalmoney = this.Fixmoney + newValue * this.Days;
      this.changealltotal();
    }
    this.updateUnitprice(newValue);
  }

  get Days() {
    return this.days;
  }
  set Days(newValue) {
    if (this.Unitprice) {
      this.Totalmoney = this.Fixmoney + newValue * this.Unitprice;
      this.changealltotal();
    }
    this.updateDays(newValue);
  }

  @Emit("update:fixmoney")
  private updateFixmoney(newValue: unknown) {
    return newValue;
  }

  @Emit("changealltotal")
  public changealltotal() {
    return;
  }
}
